module.exports = __webpack_public_path__ + "img/1.a3da4222.png";